import React, { ReactElement } from 'react';
import MuiFormControl, { FormControlProps as MuiFormControlProps, FormControlTypeMap } from '@mui/material/FormControl';
import { BpDesignSystem } from '../../types';

export type FormControlProps<
  D extends React.ElementType = FormControlTypeMap['defaultComponent'],
  P = {}
> = BpDesignSystem.PropsWithChildren<MuiFormControlProps<D, P>>;

export const FormControl = <D extends React.ElementType = FormControlTypeMap['defaultComponent'], P = {}>({
  dataTest,
  children,
  ...props
}: FormControlProps<D, P>): ReactElement => (
  <MuiFormControl {...props} data-test={dataTest}>
    {children}
  </MuiFormControl>
);
